import { createPhiSafeSentryOptions } from "@ndd/sentry";
import * as Sentry from "@sentry/react";

export function createClientSentryOptions(args: {
  dsn: string;
  environment: string;
  release?: string;
}): Parameters<typeof Sentry.init>[0] {
  return createPhiSafeSentryOptions({
    dsn: args.dsn,
    environment: args.environment,
    integrations: [Sentry.browserTracingIntegration()],
    release: args.release,
    tracesSampleRate: 1.0,
  });
}
